import {useFormContext} from 'react-hook-form'
import {useTranslation} from '@/translations/i18n'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {PageHeading} from '@/components/ui/page-atoms/PageAtoms'
import {To} from 'react-router-dom'
import {z} from 'zod'

export const ProjectFormHeading = <T extends z.ZodSchema>({
    title,
    schema,
    showConfirmationModal,
    buttonLabel,
    showSubmitButton = true
}: {
    title: string
    schema: T
    showConfirmationModal: () => void
    buttonLabel?: string
    showSubmitButton?: boolean
}) => {
    const {t} = useTranslation()
    const {
        handleSubmit,
        formState: {isValid}
    } = useFormContext<z.infer<typeof schema>>()

    const onSubmit = handleSubmit(
        () => showConfirmationModal(),
        errors => console.error('Project form submission validation errors: ', errors)
    )

    return (
        <PageHeading align="center" justify="space-between">
            <h2>{title}</h2>
            <Flexbox gap={2}>
                <ButtonLink to={-1 as To} variant="secondary">
                    {t('commons:cancel')}
                </ButtonLink>
                {showSubmitButton && (
                    <Button variant="primaryNeutral" onClick={onSubmit} disabled={!isValid}>
                        {buttonLabel || t('commons:add')}
                    </Button>
                )}
            </Flexbox>
        </PageHeading>
    )
}
